<template>
  <div class="date-picker">
    <VueDatePicker
      :name="name"
      v-model="date"
      :clearable="clearable"
      :input-class="{ 'm-0': true, 'form-control': true, 'is-danger': error }"
      :style="{ width: '100%' }"
      :disabled-date="dateToBeDisabled"
      :range="range"
      :confirm="confirm"
      :confirm-text="confirmText"
      :format="format"
      :valueType="returnType"
      :disabled="disabled"
    />
    <small class="has-error" v-if="error">{{ error }}</small>
  </div>
</template>

<script>
import VueDatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "date-picker",
  $_veeValidate: {
    // value getter
    value() {
      return this.$el.value;
    },
    // name getter
    name() {
      return this.name;
    },
  },
  components: {
    VueDatePicker,
  },
  props: {
    value: {},
    name: {
      type: String,
      default: "textInput",
    },
    input: {
      type: Function,
      default: () => {
        console.log("Default funtion triggering in select component");
      },
    },
    error: {
      type: String,
      default: "",
    },
    range: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: "YYYY-MM-DD",
    },
    confirm: {
      type: Boolean,
      default: false,
    },
    confirmText: {
      type: String,
      default: "Ok",
    },
    returnType: {
      type: String,
      default: "date",
    },
    showFromToday: {
      type: Boolean,
      default: false,
    },
    showFromTmw: {
      type: Boolean,
      default: false,
    },
    showTillToday: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date: null,
    };
  },
  watch: {
    value() {
      this.date = this.value ? this.value : null;
    },
    date() {
      this.$emit("input", this.name, this.date);
      this.$emit("change", this.name, this.date);
    },
  },
  mounted() {
    this.date = this.value ? this.value : null;
  },
  methods: {
    dateToBeDisabled(date) {
      const today = new Date();
      if (this.showFromToday) {
        today.setHours(0, 0, 0, 0);
        return today > date;
      }
      if (this.showFromTmw) return today > date;
      if (this.showTillToday) return today < date;
      return false;
    },
  },
};
</script>

<style lang="scss">
.input:focus {
  border-color: $red !important;
  box-shadow: none !important;
}
.has-error {
  color: $red;
}
.is-danger {
  border-color: $red !important;
  box-shadow: none !important;
}
</style>
